/** One destination in the rail. */

import type { CSSProperties, MouseEvent, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./NavItem.css";

export interface NavItemProps {
  readonly href: string;
  readonly active?: boolean;
  readonly badge?: ReactNode;
  readonly onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function NavItem({ href, active = false, badge, onClick, className, style, children }: NavItemProps) {
  return (
    <a
      href={href}
      aria-current={active ? "page" : undefined}
      onClick={onClick}
      style={style}
      className={cn("al-navitem", active ? "al-navitem-on" : undefined, className)}
    >
      <span className="al-navitem-label">{children}</span>
      {badge !== undefined ? <span className="al-navitem-badge">{badge}</span> : null}
    </a>
  );
}
